import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		CATAppSecured_header: {			
			position: 'relative',
			zIndex: theme.zIndex.appBar,
			display: 'flex',
			flexDirection: 'row',
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(1, 2, 1, 2),
				borderBottom: `3px solid ${theme.palette.grey[400]}`,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(.5, 2, .5, 2),
				boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.20)',
			},
		},
		CATAppSecured_body: {
			minHeight: 0,
			height: '100%',
		},
	});
}

export default styles;
